import BlueButton from "../../../../components/blue-button"
import GreenButton from "../../../../components/green-button"
import ModalsLib from '../../../../../lib/modals';

import {useSelector, useDispatch} from 'react-redux';
import Selector from '../../../../../selectors/modals/facebook/profile';
import {redeemFacebookBonus} from '../../../../../reducers/user/actions';
import Timer from './timer';
import Rewards from './rewards';
import Invite from './invite';

export default ({setStage}) => {
    const {post, tasks, uncompleted_rewards, active_bonus_time, button} = useSelector(Selector),
          dispatch = useDispatch();

    return (
        <>
            <div className="modal-header">
                <div className="modal-header-left">
                    <div className="title">Facebook Boost</div>
                    <div className="descriptions">Complete all the tasks to collect your daily bonus.</div>
                </div>
                <div className="close" onClick={e => ModalsLib.close()}>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M6 18L18 6" fill="none" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M18 18L6 6" fill="none" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </div>
            </div>
            <div className="modal-body">
                <Timer time={active_bonus_time} />

                <div className="title">Tasks</div>

                <div className={`facebook-task ${tasks.personal >= 1 ? 'done' : ''}`}>
                    <div className="task-info">
                        <div className="task-icon">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12.1601 10.87C12.0601 10.86 11.9401 10.86 11.8301 10.87C9.45006 10.79 7.56006 8.84 7.56006 6.44C7.56006 3.99 9.54006 2 12.0001 2C14.4501 2 16.4401 3.99 16.4401 6.44C16.4301 8.84 14.5401 10.79 12.1601 10.87Z" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M7.15997 14.56C4.73997 16.18 4.73997 18.82 7.15997 20.43C9.90997 22.27 14.42 22.27 17.17 20.43C19.59 18.81 19.59 16.17 17.17 14.56C14.43 12.73 9.91997 12.73 7.15997 14.56Z" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </div>
                        <div className="task-details">
                            <div className="task-name">Share to profile</div>
                            <div className="task-description">Make a repost of our post to your profile</div>
                        </div>
                    </div>
                    <div className="task-progress">
                        <div className="task-line">
                            <div className="task-progress-line" style={{width: tasks.personal >= 1 ? '100%' : '0%'}}></div>
                        </div>
                        <div className="task-value">
                            {tasks.personal} / 1
                        </div>
                    </div>
                </div>

                <div className={`facebook-task groups ${tasks.group >= 10 ? 'done' : ''}`}>
                    <div className="task-info">
                        <div className="task-icon">
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                <path d="M7.63314 9.05841C7.5498 9.05008 7.4498 9.05008 7.35814 9.05841C5.3748 8.99175 3.7998 7.36675 3.7998 5.36675C3.7998 3.32508 5.4498 1.66675 7.4998 1.66675C9.54147 1.66675 11.1998 3.32508 11.1998 5.36675C11.1915 7.36675 9.61647 8.99175 7.63314 9.05841Z" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M13.6752 3.33325C15.2919 3.33325 16.5919 4.64159 16.5919 6.24992C16.5919 7.82492 15.3419 9.10825 13.7836 9.16659C13.7169 9.15825 13.6419 9.15825 13.5669 9.16659" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M3.4666 12.1333C1.44993 13.4833 1.44993 15.6833 3.4666 17.0249C5.75827 18.5583 9.5166 18.5583 11.8083 17.0249C13.8249 15.6749 13.8249 13.4749 11.8083 12.1333C9.52494 10.6083 5.7666 10.6083 3.4666 12.1333Z" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M15.2832 16.6667C15.8832 16.5417 16.4499 16.3001 16.9165 15.9417C18.2165 14.9667 18.2165 13.3584 16.9165 12.3834C16.4582 12.0334 15.8999 11.8001 15.3082 11.6667" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </div>
                        <div className="task-details">
                            <div className="task-name">Share to groups</div>
                            <div className="task-description">Share our post to 10 thematic public groups.</div>
                        </div>
                    </div>
                    <div className="task-progress">
                        <div className="task-line">
                            <div className="task-progress-line" style={{width: tasks.group >= 10 ? `100%` : `${(tasks.group / 10)*100}%`}}></div>
                        </div>
                        <div className="task-value">
                            {tasks.group} / 10
                        </div>
                    </div>
                </div>

                {/* <div className="facebook-task-descriptions">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M8.90997 19.92L15.43 13.4C16.2 12.63 16.2 11.37 15.43 10.6L8.90997 4.08002" stroke="#DFDFEC" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>

                    <span>Complete the tasks to unlock the following bonuses for next 24 hours</span>

                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M15 19.92L8.48003 13.4C7.71003 12.63 7.71003 11.37 8.48003 10.6L15 4.08002" stroke="#DFDFEC" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </div> */}

                <Invite />
                <Rewards />
            </div>

            <div className="modal-footer">
                {uncompleted_rewards > 0 ? (
                    <GreenButton active={button} onClick={e => {
                        dispatch(redeemFacebookBonus());
                    }}>Take bonus</GreenButton>
                ) : (
                    <>
                        {(tasks.personal < 1 || tasks.group < 10) && (
                            <BlueButton onClick={e => {
                                window.open(post, '_blank');
                            }}>
                                Open post to Share
                            </BlueButton>
                        )}
                    </>
                )}
                <div className="button close" onClick={e => ModalsLib.close()}>
                    Close
                </div>
            </div>
        </>
    )
}